// extracted by mini-css-extract-plugin
export default {"holder":"RouteLayout_holder__ChLDE","content":"RouteLayout_content__OPs3l","footer":"RouteLayout_footer__+hCLD"};